<template>
    <div class="login">
        <div class="main">
            <div class="title">用戶登錄</div>
            <a-form name="normal_login" :model="formState" class="form" @finish="onFinish"
                @finishFailed="onFinishFailed">
                <a-form-item name="username" :rules="[{ required: true, message: '请输入用户名或手机' }]">
                    <a-input v-model:value="formState.username" size="large" placeholder="用户名/手机">
                        <template #prefix>
                            <UserOutlined class="site-form-item-icon" :style="{ color: '#d2d2d2' }" />
                        </template>
                    </a-input>
                </a-form-item>
                <a-form-item name="password" :rules="[{ required: true, message: '请输入密码' }]">
                    <a-input-password v-model:value="formState.password" size="large" placeholder="登录密码">

                        <template #prefix>
                            <LockOutlined :style="{ color: '#d2d2d2' }" />
                        </template>
                    </a-input-password>
                </a-form-item>
                <!-- <a-row>
                    <a-col :span="16">
                        <a-form-item name="code" :rules="[{ required: true, message: '请输入图形验证码' }]">
                            <a-input v-model:value="formState.code" size="large" placeholder="图形验证码">
                                <template #prefix>
                                    <SafetyCertificateOutlined :style="{ color: '#d2d2d2' }" />
                                </template>
                            </a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :span="2"></a-col>
                    <a-col :span="6"></a-col>
                </a-row> -->
                <a-form-item style="margin-top:10px ;">
                    <a-button type="primary" html-type="submit" size="large" block
                        :loading="formState.loading">登录</a-button>
                </a-form-item>
            </a-form>
        </div>

    </div>
</template>



<script setup>
import { reactive } from 'vue';
import { UserOutlined, LockOutlined } from '@ant-design/icons-vue';
import { loginApi } from "@/api";
import { useRouter } from "vue-router";
import { message } from 'ant-design-vue';
const formState = reactive({
    username: '',//test
    password: '',//admin123
    code: '',
    loading: false
});
const router = useRouter();
const onFinish = () => {
    formState.loading = true;
    loginApi({
        tel: formState.username,
        password: formState.password
    }).then(res => {
        localStorage.setItem('token', res.token);
        localStorage.setItem('username', formState.username);
        router.push('/');
    }).catch(err => {
        message.error(err.msg)
    }).finally(() => {
        formState.loading = false;
    })
};

const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
};
</script>

<style lang="less">
.login {
    height: 100%;
    width: 100%;
    background: url('@/assets/images/login_bg.jpg');
    background-size: 100% auto;
    padding: 110px 0;
    box-sizing: border-box;
    position: relative;

    .main {
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -155px 0 0 -210px;
        width: 420px;
        height: 310px;
        background-color: #fff;


        .title {
            padding: 35px 20px 10px 20px;
            text-align: center;
            color: #0076FE;
            font-size: 26px;

        }

        .form {
            padding: 20px 40px;
        }
    }
}
</style>